/* ══ Nota no Google (v251) ═════════════════════════════════════════
   A nota e o total da Konfidency que a ficha mostra (o onm-produto.js
   escreve em [data-media] e [data-total], dentro de [data-nota] e
   [data-nota-resumo]) entram também no Product dos dados estruturados
   que o onm-seo põe no head. Com isso o Google pode mostrar as
   estrelas na busca, com os mesmos números da tela.

   Fica num arquivo à parte e só lê a tela, sem depender de nada de
   dentro do onm-produto.js. Produto sem avaliação continua sem nota no
   schema. Se o Product já vier com nota de metacampo, vale a da tela.
   Com ?konf no endereço, o console mostra o que foi gravado.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  // só os da nota (o data-total sozinho também existe no resumo da caixa)
  var medias = document.querySelectorAll('[data-nota] [data-media], [data-nota-resumo] [data-media]');
  var totais = document.querySelectorAll('[data-nota] [data-total], [data-nota-resumo] [data-total]');
  if (!medias.length || !totais.length || !window.MutationObserver) return;
  var diag = /[?&]konf\b/.test(location.search);
  var ultima = '';

  // "4,9" vira 4.9; "1.234" (milhar no padrão brasileiro) vira 1234
  function leMedia() {
    var t = (medias[0].textContent || '').trim().replace(',', '.');
    var m = Number(Number(t).toFixed(1));
    return t && m > 0 && m <= 5 ? m : 0;
  }
  function leTotal() {
    var t = (totais[0].textContent || '').replace(/\D/g, '');
    return t ? parseInt(t, 10) : 0;
  }

  function grava() {
    var m = leMedia(), q = leTotal();
    if (!m || !q || ultima === m + '|' + q) return;
    var tags = document.querySelectorAll('script[type="application/ld+json"]');
    for (var i = 0; i < tags.length; i++) {
      var dado = null;
      try { dado = JSON.parse(tags[i].textContent); } catch (e) { continue; }
      var tipo = dado && dado['@type'];
      if (tipo !== 'Product' && !(Array.isArray(tipo) && tipo.indexOf('Product') > -1)) continue;
      dado.aggregateRating = { '@type': 'AggregateRating', ratingValue: m, reviewCount: q, bestRating: 5, worstRating: 1 };
      tags[i].textContent = JSON.stringify(dado);
      ultima = m + '|' + q;
      if (diag && window.console) console.info('ON: nota no schema do produto', m, q);
      return;
    }
  }

  // a nota pode já estar na tela (cache do navegador ou metacampo)
  grava();
  var obs = new MutationObserver(grava);
  [medias[0], totais[0]].forEach(function (el) {
    obs.observe(el, { childList: true, characterData: true, subtree: true });
  });
})();
